import { render } from "./Carrinho.vue?vue&type=template&id=85feec96&scoped=true"
import script from "./Carrinho.vue?vue&type=script&lang=js"
export * from "./Carrinho.vue?vue&type=script&lang=js"

import "./Carrinho.vue?vue&type=style&index=0&id=85feec96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85feec96"]])

export default __exports__